import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "../context/AuthContext";
import { Box, CircularProgress, Typography } from "@mui/material";

export default function RootRedirect() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return; // attend que AuthContext soit prêt

    if (!user) {
      navigate("/login", { replace: true });
    } else if (user.role === "admin") {
      navigate("/dashboard/home", { replace: true });
    } else if (user.role === "client") {
      navigate("/app/home", { replace: true });
    } else {
      navigate("/login?error=no-role", { replace: true });
    }
  }, [user, loading, navigate]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh" }}>
      <Typography>Chargement...</Typography>
      <CircularProgress />
    </Box>
    )
}
